import { Component } from '@angular/core';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { LeadEngineerInstalledComponent } from '../lead-engineer-installed/lead-engineer-installed.component';
import { LeadEngineerRemovedComponent } from '../lead-engineer-removed/lead-engineer-removed.component';
import { LeadEngineerInstalledSaveComponent } from '../lead-engineer-installed-save/lead-engineer-installed-save.component';
import { LeadEngineerRemovedSaveComponent } from '../lead-engineer-removed-save/lead-engineer-removed-save.component';
import { LeadEngineerService } from '../../../services/leadengineer.service';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-lead-engineer-home',
    imports: [NextPage, ButtonModule, DropdownModule, TableModule, LeadEngineerInstalledComponent, NgIf, LeadEngineerInstalledSaveComponent, LeadEngineerRemovedComponent, LeadEngineerRemovedSaveComponent],
    templateUrl: './lead-engineer-home.component.html',
    styleUrl: './lead-engineer-home.component.scss'
})
export class LeadEngineerHomeComponent {

  isLoading: boolean = false;
  isLoadingTwo: boolean = false;
  isLoadingOne: boolean = false;
  leadEngineerData = [];
  leadEngineerRemovedData = [];
  constructor(private leadEngineerService: LeadEngineerService) { }


  ngOnInit() {
    this.isLoading = true;
    this.isLoadingOne = true;
    this.isLoadingTwo = true;
    this.setOaData();
    this.setOaRemovedData();
  }

  setOaData() {
    // Remove hardcoded 'ES' to use facilityId from localStorage
    this.leadEngineerService.getAllData().subscribe({
      next: (data: any) => {
        if (data) {
          this.leadEngineerData = data;
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      },
      complete: () => {
        this.isLoadingOne = false;
      }
    });
  }

  setOaRemovedData() {
    // Remove hardcoded 'ES' to use facilityId from localStorage
    this.leadEngineerService.getRightData().subscribe({
      next: (data: any) => {
        if (data) {
          this.leadEngineerRemovedData = data;
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      },
      complete: () => {
        this.isLoadingTwo = false;
      }
    });
  }
}
